<template>
<div>
  <div class="cover" :style="background_image ? `background-image: url(${background_image})` : ``"></div>
  <div class="container p-30 py-50">
    <Logo class="mb-30" />
    <div v-if="!has_click_n_go">
      <div class="fs-14 lh-1-4">Network registration methods are not correctly configured. Please contact an Allbridge support representative.</div>
    </div>
    <div v-if="has_click_n_go">
      <div class="fs-36 mb-30">Pretty fly for a WiFi</div>
      <div class="fs-14 mb-20 lh-1-4">Sign up for news, offers and events from The Hoxton.</div>
      <div class="mb-15 p-rel input-container">
        <input v-model="form.email_address" type="text" placeholder="enter email here..." />
        <div class="cursor-pointer icon-submit" @click="handleClickConnect()">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/></svg>
        </div>
      </div>
      <button class="mb-15 fs-14" @click="handleClickConnect()" :disabled="disabled">
        {{this.form.email_address ?
          `Sign up and continue`
          :
          `No thanks, take me straight to the WiFi`
        }}
      </button>
      <div class="fs-11 lh-1-4">Learn more about <a href="https://thehoxton.com/privacy-policy/" target="_blank">how we use your data</a>. By using our wifi, you agree to our <a href="https://thehoxton.com/terms-of-use/" target="_blank">terms and conditions</a>.</div>
    </div>
    <!-- <SupportAndDeviceInfo :phone="portal.template.support_phone" :ip="connection_data.client_ip" :mac="connection_data.client_mac" /> -->
  </div>
</div>
</template>

<script>
import Logo from '@/components/custom/hoxton/Logo'
import TermsOfService from '@/utilities/TermsOfService'
import Axios from "axios";
// import SupportAndDeviceInfo from '@/utilities/SupportAndDeviceInfo'

export default {
  name: 'custom_template_hoxton',
  props: [ 'background_image', 'template', 'portal', 'connection_data', 'revinate_token' ],
  components: { Logo, TermsOfService }, // SupportAndDeviceInfo
  data(){
    return{
      revinate_url: 'https://contact-api.inguest.com/api/add-contacts-to-lists',
      disabled: false,
      form: {
        email_address: null,
      },
    }
  },
  computed: {
    has_click_n_go: function(){
      return this.portal.registration_methods.findIndex(registration_method => registration_method.registration_method_id === 1) !== -1;
    }
  },
  watch: {
    'form': {
      deep: true,
      handler(){ this.disabled = false }
    }
  },
  created(){
    document.documentElement.classList.add('hoxton');
  },
  methods: {
    handleClickConnect: function(){
      if(this.disabled) return;
      this.disabled = true;
      const method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 1);
      const rateplan = method.rate_plans[0];
      const include_email = !!this.form.email_address && !!this.form.email_address.trim();
      const data = {
        registration_method_id: method.registration_method_id,
        rateplan_id: rateplan.rateplan_id,
        ...(include_email && { email_address: this.form.email_address }),
        ...(include_email && { email_opt_in: 1 }),
      }
      const revinate_data = {
        tokens: [ this.revinate_token ],
        contacts: [
          {
            ...(this.form.email_address && { email: this.form.email_address }),
              subscribed: this.subscribe
          }
        ]
      };
      Axios.post(this.revinate_url,revinate_data).then(response => {
        this.$emit('emitRegistrationMethodData', data );
      }).catch( error => {
        this.$emit('error', 'Error registering with email address.');
      });
    },
  }
}
</script>
<style>
.cover { display: none; }
@media screen and (min-width: 601px) {
  .hoxton { background: #ccc; }
  .cover { display: block; }
}
.hoxton .container { border-radius: unset; max-width: 565px; }
.hoxton #app, .hoxton input, .hoxton button { font-family: Helvetica, Arial, sans-serif; }
.hoxton a { color: #555; text-decoration: underline; }
.hoxton input { outline: none; color: #000; padding: 10px 0; line-height: 1; border: 0; border-bottom: 1px solid #808080; width: 100%; }
.hoxton .icon-submit { color: #555; position: absolute; right: 0; top: 0; bottom: 0; display: flex; align-items: center; justify-content: center;  }
.hoxton .input-container { width: 300px; margin-left: auto; margin-right: auto; }
.hoxton button {  background: transparent; padding: 10px 30px; font-weight: bold; border: 0; cursor: pointer; }
</style>
